<template>
  <div
    class="field-render"
    :class="{'active' : isCurrent}"
  >
    <my-form
      ref="commonOptionFormRef"
      :option="option"
      :data="data"
      :footer-visible="false"
      width="auto"
    />

    <div
      v-if="isCurrent"
      class="operation"
    >
      <b-button
        variant="outline-primary"
        class="btn-icon rounded-circle ml-1"
        :class="{'disabled-btn': column.formOption.formEditDisabled}"
        size="sm"
        :disabled="column.formOption.formEditDisabled"
        @click.stop="$emit('clone')"
      >
        <feather-icon icon="CopyIcon" />
      </b-button>

      <b-button
        variant="outline-danger"
        class="btn-icon rounded-circle ml-1"
        :class="{'disabled-btn': column.formOption.formEditDisabled}"
        size="sm"
        :disabled="column.formOption.formEditDisabled"
        @click.stop="$emit('delete')"
      >
        <feather-icon icon="Trash2Icon" />
      </b-button>
    </div>
  </div>
</template>

<script>
import {
  BFormInput, BButton,
} from 'bootstrap-vue'
import ElementComponent from '@/components/elementComponent.vue';
import MyForm from '@/components/myForm/index.vue'

export default {
  components: {
    // BFormInput,
    BButton,
    // ElementComponent,
    MyForm,
  },
  props: {
    column: {
      type: Object,
      default: () => {},
    },
    isCurrent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: {},
    }
  },
  computed: {
    option() {
      const col = this.column
      col.formOption.updateNow = true
      return {
        columns: [col] || [],
        defaultValueFirst: true,
        hideSpan: true,
      }
    },
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(e) {
        this.$emit('change', e)
      },
    },
  },
}

</script>

<style lang='scss' scoped>
// Core variables and mixins
@import '~@core/scss/base/bootstrap-extended/include';
// Overrides user variable
@import '~@core/scss/base/components/include';
.field-render{
    cursor: move;
    position: relative;
    min-height: 55px;
    padding: 5px 10px 10px;
    &:hover{
        background: #ecf8ff;
    }
    .operation{
        position: absolute;
        right: 10px;
        bottom: -15px;
        z-index: 9;
        .btn-icon{
            background: #FFF;
        }
    }
    .disabled-btn{
      cursor: not-allowed;
      background-color: #eee !important;
    }
}
.active{
    background: #ecf5ff;
    &::before{
        content: '';
        position: absolute;
        background: $primary;
        left: 0;
        top: 0;
        height: 100%;
        width: 3px;
    }
}
</style>

<style lang="scss">
.field-render{
  .my-form{
    padding: 0 !important;
  }
}
</style>
